/**
 * src/db/platform.db.js
 *
 * Datos de la sección "Una plataforma creada para conectar Fusagasugá".
 */

export const platformData = {
    section: {
        headline:    'Una plataforma creada para conectar Fusagasugá',
        description: 'UBIYAAA reúne movilidad, negocios locales, promociones y servicios en un solo lugar pensado para la ciudad.'
    },
    features: [
        {
            id:          1,
            icon:        '🚗',
            title:       'Movilidad rápida',
            description: 'Pide transporte particular de forma rápida y segura sin salir de la plataforma. Conductores locales, tarifas claras.',
            color:       'green'
        },
        {
            id:          2,
            icon:        '🗺️',
            title:       'Directorio local',
            description: 'Encuentra negocios, restaurantes, servicios profesionales y comercios de Fusagasugá organizados por categoría.',
            color:       'blue'
        },
        {
            id:          3,
            icon:        '🎁',
            title:       'Promociones de la ciudad',
            description: 'Accede a descuentos exclusivos, lanzamientos y novedades de los mejores negocios locales cada semana.',
            color:       'orange'
        }
    ]
}
